import { QueryFanoutInsights } from '@/common/model/media/queryFanout'

import GeoInsightsPanel, {
  InsightBlock
} from '@/components/container/modules/mediaGeo/common/GeoInsightsPanel'

interface Props {
  insights: QueryFanoutInsights
}

// インサイト（最強／最弱段階・AIの改善案）
const QueryFanoutInsightsPanel = ({ insights }: Props) => {
  const blocks: InsightBlock[] = [
    ...(insights.strongest_stage
      ? [{ title: '最強段階', tone: 'positive' as const, texts: [insights.strongest_stage] }]
      : []),
    ...(insights.weakest_stage
      ? [{ title: '最弱段階', tone: 'negative' as const, texts: [insights.weakest_stage] }]
      : [])
  ]

  return <GeoInsightsPanel blocks={blocks} recommendation={insights.recommendation} />
}

export default QueryFanoutInsightsPanel
